export default __webpack_public_path__ + "static/media/Group 12077.47829551.svg";